// store/modules/product.js
import axios from 'axios';

const dashboardModule = {
    namespaced: true,
    state() {
        return {
            order: [],
            totalOrderLoading: false,
            totalDashboardOrder: [],
            dashboardReview: [],
            dashboardReviewLoading: false,
            dashboardProductReviews:[],
            viewOrderLoading : false,
            viewOrderData:[]
        }
    },
    mutations: {
        SET_ORDER(state, data) {
            state.order = data
        },
        SET_ORDER_LOADING(state, loading) {
            state.totalOrderLoading = loading
        },
        SET_TOTAL_ORDER(state, data) {
            state.totalDashboardOrder = data
        },
        SET_DASHBOARD_REVIEW(state, data){
            state.dashboardReview = data
        },
        SET_DASHBOARD_REVIEW_LOADING(state, loading){
            state.dashboardReviewLoading = loading
        },
        SET_DASHBOARD_PROUDCT_REVIEW(state,data){
          state.dashboardProductReviews = data;
        },
        SET_VIEW_ORDER_LOADING(state,loading){
            state.viewOrderLoading = loading;
        },
        SET_VIEW_ORDER(state, data){
          state.viewOrderData = data;
        },
    },

    actions: {

        async fetchOrderAll({ commit }, { page = 1}) {
            const url = `/api/orders?page=${page}`;
            const token = localStorage.getItem('token');

            // Check if token exists in localStorage
            if (!token) {
                console.log('No token found in local storage, API call not made.');
                return;
            }

            try {
                // Set loading state before making the API call
                commit('SET_ORDER_LOADING', true);

                // Perform the API call with Authorization headers
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                // Commit response data to the store
                commit('SET_ORDER', response.data);
            } catch (error) {
                // Log any errors and set loading state to false
                console.error('Error fetching orders:', error);
            } finally {
                // Ensure that loading state is always set to false
                commit('SET_ORDER_LOADING', false);
            }
        },

        async ViewOrder({commit} ,{id}){
          const url = `/api/view_order/${id}`;
            const token = localStorage.getItem('token');

            if (!token){
                console.log('No token found in local storage, API call not made.');
                return;
            }

            try {
                commit('SET_VIEW_ORDER_LOADING' ,true);

                let response = await axios.get(url ,{
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                    // console.log( 'VIEW ORDER',response.data);
                commit('SET_VIEW_ORDER' ,response.data);
                commit('SET_VIEW_ORDER_LOADING' ,false);
            }catch (e) {
                console.log(e);
            }
        },

        async fetchTotalOrder({ commit }) {
            const url = `/api/dashboard`;
            const token = localStorage.getItem('token');

            // Check if the token exists before making the API call
            if (!token) {
                console.log('No token found in local storage, API call not made.');
                return; // Exit the function early if no token is found
            }

            try {
                let response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                });
                commit('SET_TOTAL_ORDER', response.data);
            } catch (errors) {
                console.log(errors);
            }
        },


        async fetchReview({commit} , {page}){
            const url = `/api/my-reviews?page=${page}`;
            const token = localStorage.getItem('token');
            try{
                commit('SET_DASHBOARD_REVIEW_LOADING', true)
                let response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                });
                commit('SET_DASHBOARD_REVIEW_LOADING', false);
                commit('SET_DASHBOARD_REVIEW', response.data.reviews);
            } catch(errors){
                console.log(errors)
            }
        },

        async fetchProductReview({commit} , {page}){
            const url = `/api/fetch-product-reviews?page=${page}`;
            const token = localStorage.getItem('token');
            try {
            commit('SET_DASHBOARD_REVIEW_LOADING' ,true);

            let response = await axios.get(url,{
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            });
            commit('SET_DASHBOARD_REVIEW_LOADING',false);
            commit('SET_DASHBOARD_PROUDCT_REVIEW',response.data);
            }catch (errors){
                console.log(errors);
            }
        },



    },

    getters:{
        formattedRole(state, getters, rootState) {
            const user = rootState.auth.user; // Access user from rootState
            if (user && user.role) {
                return user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase();
            }
            return 'Guest';
        },
        showUserImage: () => (imagePath) => {
            // Ensure imagePath is valid, fallback to a default image if not
            if (!imagePath) return '/images/default-image.jpeg';
            return `${window.location.origin}/${imagePath}`;
        },
        pages(state) {
            const totalPages = state.order.last_page || 1;
            const pages = [];
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
            return pages;
        }
    }



}


export default dashboardModule;
